export enum LegacyReferralNotificationResponseStatusEnum {
  NeedsResponse = 1,
  Responded = 2
}

export const LegacyReferralNotificationResponseStatusOptions = [
{ id: 1, label: 'Needs Response' },
{ id: 2, label: 'Responded' }
];
